

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultCounterCard from "parts/Cards/CounterCards/DefaultCounterCard";


function Featuring() {
  return (
    <MKBox component="section" pt={3} pb={8}>
      <Container>
        
        <Grid container justifyContent="center" sx={{ textAlign: "center" }}>
        <Grid item xs={12} md={3}>
            <DefaultCounterCard
              count={3}
              separator=","
              suffix="+"
              title="Years"
              description="Decades of experience meeting and exceeding quality standards, ensuring all projects align with the specific needs and expectations of our users."
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DefaultCounterCard
              count={1000}
              separator=","
              suffix="+"
              title="Projects"
              description="Successfully delivered high-performance projects, each led by a certified project manager to ensure effective execution and quality."
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DefaultCounterCard
              count={300}
              suffix="+"
              separator=","
              title="Clients"
              description="Proudly serving 300+ clients worldwide across various industries, ensuring consistent results and customer satisfaction."
            />
          </Grid>
          
          <Grid item xs={12} md={3}>
            <DefaultCounterCard
              count={24}
              suffix="/7"
              title="Support"
              description="Dedicated team members providing round-the-clock support, ensuring projects are completed on time and with the highest level of engagement."
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Featuring;
